import styled from "styled-components";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";
import {grayColors} from "../../../../../themes/architecture/gray-colors";

export const AdvancedGamesFilterHeaderDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: ${props => props.theme.colors.textLight};
    background-color: ${props => hexToRgba(grayColors.gray023, 0.25)};
    padding: 15px;
    width: 100%;
    height: 50px;
`;
